import React from 'react';
import { Form } from 'react-bootstrap';
import { Person } from '../types/form';
import { getPosition } from '../helpers/position';

interface FormPositionProps {
  person: Person;
  position: string | null;
  setPosition: (position: string | null) => void;
}

function FormPosition({ person, position, setPosition }: FormPositionProps) {
  return (
    <Form.Group className="mb-3" controlId="formPosition">
      <Form.Label>Pełniona funkcja:</Form.Label>
      <Form.Control as="textarea" rows={2} value={position || ''} onChange={(event: any) => {
        setPosition(event.target.value || null);
      }} placeholder={`np. ${getPosition(person)}`} />
    </Form.Group>
  );
}

export default FormPosition;
